<template>
		<div>
			<div class="crumbs">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/monitorCAAList' }">
						<i class="el-icon-video-camera"></i> 视频管理
					</el-breadcrumb-item>
					<el-breadcrumb-item>添加视频</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="container">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="155px">
					<el-row>
						<el-col :span="24">
							<el-form-item :label="'所属幼儿园'" prop="caaSAAI">
								<el-select v-model="ruleForm.caaSAAI" clearable filterable :placeholder="'请选择幼儿园'" class="handle-select mr10" @change="SAAIchange">
									<el-option v-for="item in ruleForm.optionsSAAI" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item :label="'视频类别'" prop="caaSTID">
								<el-select v-model="ruleForm.caaSTID" clearable :placeholder="'请选择类别'" class="handle-select mr10" :disabled="STIDdisabled">
									<el-option v-for="item in ruleForm.optionsSTID" :key="item.CFLSTID" :label="item.CFLNAME" :value="item.CFLSTID">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item :label="'视频名称'" prop="caaNAME">
								<el-input v-model="ruleForm.caaNAME" :placeholder="'请输入视频名称'" maxlength="20"></el-input>
								<div>
									<span style=" width:250%; height: 10px; padding-top: 10px; font-size: 14px;color: #999999;">
										（例：操场）
									</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item :label="'当前状态'" prop="caaNOST" v-show="false">
								<el-select v-model="ruleForm.caaNOST" clearable :placeholder="'请选择状态'" class="handle-select mr10">
									<el-option v-for="item in ruleForm.optionsNOST" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item :label="'通道号'" prop="caaCHAL">
								<el-input v-model="ruleForm.caaCHAL" :placeholder="'请输入通道号'" maxlength="2"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item :label="'RTSP视频源地址'" prop="caaRTSP">
								<el-input v-model="ruleForm.caaRTSP" :placeholder="'请输入RTSP视频源地址'" maxlength="100"></el-input>
								<!-- <div style="margin-top: 20px;width:600px;">
									<el-button type="primary" @click="getRTMP('ruleForm')">生成</el-button>
									<span style="margin-left: 10px; font-size: 14px;color: #999999;">123456</span>
								</div> -->
							</el-form-item>
						</el-col>
					</el-row>
					<!-- 视频开放时间段模板ID -->
					<el-row>
						<el-form-item :label="'视频开放时间段模板'" prop="scaMSID">
							<el-select v-model="ruleForm.scaMSID" clearable :placeholder="'请选择时间段模板'" class="handle-select mr10" :disabled="STIDdisabled">
								<el-option v-for="item in ruleForm.optionsSCA" :key="item.SCAMSID" :label="item.SCANAME" :value="item.SCAMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-row>
					<el-row>
						<el-col :span="24">
							<div class="submit">
								<el-form-item>
									<el-button @click="goBack()" class="goback" :loading="btnLoading">返回</el-button>
									<el-button type="primary" @click="submitForm('ruleForm')" :loading="btnLoading">提交</el-button>
									<!-- :show-close="false" -->
									<el-dialog title="提示" :visible.sync="dialogVisible" width="50%" :before-close="goMonitorList" :close-on-click-modal="false">
										<span>请将此地址粘贴到对应onvif设置</span>
										<el-form-item :label="'RTMP推流地址:'">
											<span style="font-size: 16px;font-weight: bold;">{{ruleForm.caaRTMP}}</span>
										</el-form-item>
										<span slot="footer" class="dialog-footer">
											<el-button @click="dialogVisible = false;goMonitorList()">确 定</el-button>
											<el-button type="primary" @click="dialogVisible=false;loadCAA()">继续添加</el-button>
										</span>
									</el-dialog>
									
								</el-form-item>
							</div>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
</template>

<script>
	export default {
		name: 'addMonitorCAA',
		data() {
			//验证字符串
			const validateFontSize = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入视频名称')) //长度在1-20之间
				} else if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					this.checkCAANAME(value);
					if (this.isRepeatNAME == true) {
						callback(new Error('视频名称重复'));
					} else {
						callback();
					}
				}
			}
			
			//验证RTSP
			const validateRTSP = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入RTSP视频源地址'))
				} else {
					this.checkCAARTSP(value);
					if (this.isRepeatRTSP == true) {
						callback(new Error('RTSP视频源地址重复'));
					} else {
						callback();
					}
				}
			}
			
			const validateSERI = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入设备序列号')) 
				} else if (value.toString().length < 1 || value.toString().length > 9) {
					callback(new Error('请输入长度在1~9之间的字符')) //长度在1-9之间
				} else {
					this.checkCAASERI(value);
					if (this.isRepeatSERI == true) 
					{
						callback(new Error('此设备序列号已存在，请勿重复添加'));
					} 
					else
					{
						callback();
					}
				}
			}

			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				STIDdisabled: true,
				dialogVisible: false,
				startTime: '07:00',
				isRepeatNAME: false,
				isRepeatSERI: false,
				isRepeatRTSP: false,
				btnLoading: false,
				ruleForm: {
					caaMSID: '',
					
					caaSAAI: '',
					optionsSAAI: [],//所属幼儿园
					
					caaNAME: '',
					
					caaSTID: '',
					optionsSTID: [],//视频类别
					
					caaNOST: '',
					optionsNOST: [],//当前状态
					
					caaCHAL:'',//通道号
					caaRTSP:'',
					caaRTMP:'',
					boolRTMP:true,//生成按钮是否可用
					
					scaMSID: '',
					optionsSCA: []//开放时间模板
				},
				rules: {
					caaNAME: [{
						required: true,
						trigger: ['blur', 'change'],
						validator: validateFontSize
					}],
					caaSAAI: [{
						required: true,
						message: '请选择幼儿园',
						trigger: ['blur', 'change']
					}],
					caaSTID: [{
						required: true,
						message: '请选择类别',
						trigger: ['blur', 'change']
					}],
					caaCHAL: [{
						required: true,
						message: '请输入通道号',
						trigger: ['blur', 'change']
					}],
					caaRTSP: [{
						required: true,
						trigger: ['blur', 'change'],
						validator: validateRTSP
					}],
					scaMSID: [{
						required: true,
						message: '请选择视频开放时间段模板',
						trigger: ['blur', 'change']
					}]
				}
			};
		},
		created() {
			this.getSAAI(); //幼儿园
			this.getNOST(); //状态
		},
		methods: {
			//要继续添加下一条视频信息吗
			loadCAA(){
				this.ruleForm.caaMSID=''
				this.ruleForm.caaNAME=''
				this.ruleForm.caaCHAL=''
				this.ruleForm.caaRTSP=''
				this.ruleForm.caaRTMP=''
				this.clearValidate('ruleForm'); 
				this.btnLoading = false;
				//this.$refs['ruleForm'].validate((valid) => {});//模拟一次提交表单,必填项就会提示红字
			},
			clearValidate(formName) {
			    //this.$refs[formName].clearValidate();
			    this.$refs[formName].resetFields();
			},
			//获取状态信息
			getNOST() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sINIKEY1: 10007 //状态
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsNOST = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取当前状态请求失败', //请求失败
							type: 'error'
						});

					});
			},
			//获取幼儿园信息
			getSAAI() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon //web侧 登录邮箱
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsSAAI = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取幼儿园请求失败', //请求失败
							type: 'error'
						});

					});
			},
			//获取视频开放时间段模板信息
			getSCAMSID(caaSAAI) {
				const self_shop = this;
				
				var postUrl = 'WCF/WEB/svcSCA.svc/Get_CAASCA_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sSAAI: caaSAAI  //所属幼儿园
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					
					if (resCount > 0) {
						this.ruleForm.optionsSCA = response.data.KKDT;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
		
				});
			},
			//获取类别信息
			getSTID(caaSAAI) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcCFL.svc/Get_CFL_BYSAAI';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sSAAI: caaSAAI //所属幼儿园
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsSTID = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取类别请求失败', //请求失败
							type: 'error'
						});

					});
			},
			//验证此幼儿园下，视频名称是否重复
			checkCAANAME(value) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcCAA.svc/CHECK_CAA_NAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sSAAID: self_shop.ruleForm.caaSAAI,
						sCAAID: null,
						sCAANM: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeatNAME = true;
					} else {
						this.isRepeatNAME = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取幼儿园请求失败', //请求失败
						type: 'error'
					});
				});
			},
			//验证RTSP是否已存在
			checkCAARTSP(value) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcCAA.svc/CHECK_CAA_RTSP';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sCAAID: null,
						sRTSP: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeatRTSP = true;
					} else {
						this.isRepeatRTSP = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '验证RTSP请求失败',
						type: 'error'
					});
				});
			},
			
			//验证此序列号在CAA是否已存在
			checkCAASERI(value) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcCAA.svc/CHECK_CAA_CAASERI';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sCAAID: null,
						sCAASERI: value //设备序列号
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeatSERI = true;
					} else {
						this.isRepeatSERI = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			
			//视频新增
			submitForm(formName){
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.btnLoading = true;
						const self = this;
						var postUrl = 'WCF/WEB/svcCAA.svc/ADD_CAA';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
									sCAASAAI: self.ruleForm.caaSAAI ? self.ruleForm.caaSAAI : '',
									sCAASTID: self.ruleForm.caaSTID ? self.ruleForm.caaSTID : '',
									sCAANAME: self.ruleForm.caaNAME,
									sCAACHAL: self.ruleForm.caaCHAL,//通道号
									sCAARTSP: self.ruleForm.caaRTSP,
									sCAASCAI: self.ruleForm.scaMSID
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;
								
								if (resStatus == "200") {
									if (resKKSTR.substring(0,1) == "Y") {
										//this.$message.success('添加视频成功'); // 添加视频成功
										self.ruleForm.caaRTMP = resKKSTR.split('_')[1].toString()
										
										setTimeout(() => {								 
										    this.dialogVisible = true;	 
										}, 4000);
									}
									else
									{
										this.$message({
											message: '保存请求失败', //请求失败
											type: 'error'
										});
									}
								} 
								else
								{
									this.$message({
										message: '保存请求失败', //请求失败
										type: 'error'
									});
								}
								
							})
							.catch((error) => {
								this.$message({
									message: '请求失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '提交失败', //表单验证失败
							type: 'error'
						});
					}
				});
			},
			
			goMonitorList() {
				this.$router.push('/monitorCAAList') // 跳转路由
				this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "addMonitorCAA") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			},
			// 幼儿园选择事件
			SAAIchange() {
				console.log("---SAAIchange--" + this.ruleForm.caaSAAI);
				if (typeof(this.ruleForm.caaSAAI) !== 'undefined') {
					this.getSTID(this.ruleForm.caaSAAI);
					this.getSCAMSID(this.ruleForm.caaSAAI); //视频开放时间段模板
					
					this.ruleForm.caaNAME = '';
					this.ruleForm.caaSTID = '';
					this.ruleForm.scaMSID = '';
					this.STIDdisabled = false;

				} else {
					this.STIDdisabled = true;
				}
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "addMonitorCAA") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}

		}

	}
</script>
<style scoped>
	.font {
		font-size: 14px;
	}

	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 5px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}

	.handle-select-y {
		width: 45%;
	}
</style>
